import { render, staticRenderFns } from "./CustomerUpdateDialogPhone.vue?vue&type=template&id=298e680a&scoped=true"
import script from "./CustomerUpdateDialogPhone.vue?vue&type=script&lang=ts"
export * from "./CustomerUpdateDialogPhone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298e680a",
  null
  
)

export default component.exports